import React from 'react';
import './Card.css';

const Card = ({ children, className = '' }) => {
    return ( <
        div className = { `card ${className}` } > { children } <
        /div>
    );
};

export const CardContent = ({ children }) => {
    return <div className = "card-content" > { children } < /div>;
};

export default Card;